import { FileAttachmentType } from './file-attachment.model';

export class SourceSealModel {
  data: string;
  sealNumber: string;
  filename: string;
  mimeType: FileAttachmentType;
}
export class AttachmentSealModel {
  attachmentId: string;
  sealNumber: string;
  filename: string;
  mimeType: FileAttachmentType;
}
